import type { InvoiceFormSchema } from './steps/invoice-form/schema';
import type { WizardValuesBase } from '@/context/wizard/types';

export enum InvoiceWizardStepIds {
  InvoiceForm = 'invoice-form',
  Summary = 'summary',
  Details = 'details',
}

export interface InvoiceWizardProps extends WizardValuesBase {
  currentStepId: InvoiceWizardStepIds;
  canEdit: boolean;
  data: InvoiceFormSchema;
}
